/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_ReusedInputs */

const en_directory_submit_enrich_reused = /** @type {(inputs: Directory_Submit_Enrich_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cached`)
};

const zh_directory_submit_enrich_reused = /** @type {(inputs: Directory_Submit_Enrich_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复用`)
};

/**
* | output |
* | --- |
* | "cached" |
*
* @param {Directory_Submit_Enrich_ReusedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_reused = /** @type {((inputs?: Directory_Submit_Enrich_ReusedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_ReusedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_reused(inputs)
	return zh_directory_submit_enrich_reused(inputs)
});
export { directory_submit_enrich_reused as "directory.submit.enrich.reused" }